import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Badge, Button, FlexColumn, FlexRow, Typography } from "design-system";
import { ArrowRightIcon } from "design-system/components/Icons";
import LearningShell from "../../components/LearningShell";
import WarningBanner from "../../components/WarningBanner";
import WhatsInvolved from "../../components/WhatsInvolved";

export default function CourseIntro({ course, onStartGuidance }) {
  const intl = useIntl();

  return (
    <LearningShell showWarning={false}>
      <FlexColumn align="stretch" fullWidth className="ld-course-intro">
        <FlexColumn align="stretch" fullWidth gap={10}>
          <FlexRow align="center" fullWidth={false} wrap gap={10}>
            {course.category ? (
              <Badge variant="primary" emphasis="subtle" size="md">
                {course.category}
              </Badge>
            ) : null}
            {course.dueDate ? (
              <Typography component="span" variant="bodySmall">
                {intl.formatMessage(
                  { id: "ld-due-date" },
                  { date: course.dueDate },
                )}
              </Typography>
            ) : null}
          </FlexRow>

          <Typography
            component="h1"
            variant="displayMedium"
            fontWeight="bold"
            className="ld-course-intro__title"
            color="ui-emphasis"
          >
            {course.title}
          </Typography>

          <Typography
            component="p"
            variant="bodyMedium"
            fontWeight="regular"
            color="ui-subtle"
          >
            {course.description}
          </Typography>
        </FlexColumn>

        <WhatsInvolved items={course.whatsInvolved} />

        <FlexColumn
          align="start"
          fullWidth
          gap={20}
          className="ld-course-intro__footer"
        >
          <WarningBanner
            message={intl.formatMessage({ id: "ld-progress-warning" })}
          />
          <FlexRow align="start" fullWidth={false}>
            <Button
              variant="primary"
              size="base"
              icon={<ArrowRightIcon size={18} />}
              iconPosition="right"
              onClick={onStartGuidance}
              className="ld-course-intro__start-guidance"
            >
              {intl.formatMessage({ id: "ld-start-guidance" })}
            </Button>
          </FlexRow>
        </FlexColumn>
      </FlexColumn>
    </LearningShell>
  );
}

CourseIntro.propTypes = {
  course: PropTypes.shape({
    description: PropTypes.string,
    logoSrc: PropTypes.string,
    category: PropTypes.string,
    dueDate: PropTypes.string,
    title: PropTypes.string.isRequired,
    whatsInvolved: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onStartGuidance: PropTypes.func.isRequired,
};
